import { Stack, Text } from '~/components-v2'
import { Person } from '~/types'
import { PublishDate } from './publish-date'
import { personPhotoSrc } from '../human'
import { SizeValues } from '~/components-v2/stack/stack'

export const Author = ({
  name,
  email,
  photo,
  gap = 3,
}: Person & { gap?: SizeValues }) => {
  return (
    <Stack as="span" align="center" row className="author" gap={gap}>
      {photo && (
        <img src={personPhotoSrc(photo, 52)} alt={name} className="photo" />
      )}
      {email ? <a href={`mailto:${email}`}>{name}</a> : name}
    </Stack>
  )
}

export const Byline = ({
  authors,
  date,
}: {
  authors: Person[]
  date: Date
}) => (
  <Stack className="byline">
    <Text fontWeight={700} fontSize="sm">
      <PublishDate date={date} />
    </Text>
    <Stack gap={3}>
      {authors.map((author) => (
        <Author key={author.slug} {...author} />
      ))}
    </Stack>
  </Stack>
)
